<template>
  <div class="total">
    <extension tool-title="国际货件在线查询" class="tools">
      <div class="search_module">
        <div class="search_top">
          <div class="search_img">
            <img src="../img/快递公司选择.png" alt="">
          </div>
          <label>
            <input type="text" v-model="expressInquiry" placeholder="请输入物流单号查询" @input="changeNecessary" @blur="cancelExpress" @focus="showExpress">
          </label>
          <button @click="inquire">货件查询</button>
        </div>
        <div v-if="expressData !== null" class="search_bottom">
          <div v-for="(item, index) in expressData.data" :key="index" class="express_item">
            <div class="express_time">{{item.time}}</div>
            <img v-if="index === 0" src="../img/圆形选中（绿）.png" alt="" class="express_img">
            <img v-else src="../img/圆形选中.png" alt="" class="express_img">
            <div class="express_context">{{item.context}}</div>
          </div>
        </div>
        <div v-if="companyShow || showExpressDetail" class="company_show" @mouseenter="showDetail" @mouseleave="cancelDetail">
          <div v-for="(item, index) in expressCompany" :key="index" @click="inquireDetail(index)">{{expressInquiry}}&nbsp;{{item.comCodeZh}}</div>
        </div>
      </div>
    </extension>
    <div v-for="(item, index) in tools" :key="index" class="tools">
      <tool :tool-title="titles[index]" :tools="item"></tool>
    </div>
  </div>
</template>

<script>
  import siteTools from "../common/siteTools";
  import extensionTool from "@/components/content/extensionTool";
  import {request} from "@/network/request";

  // 亚马逊常用小工具
  let array_1 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/快递100.png'),
      // 名字
      name: '快递100',
      // 站外链接
      hrefSelf: 'https://www.kuaidi100.com/',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/环球海运查询.png'),
      // 名字
      name: '环球海运查询',
      // 站外链接
      hrefSelf: 'http://www.global56.com/ship/orderquery.asp',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/17TRACK.png'),
      // 名字
      name: '17TRACK',
      // 站外链接
      hrefSelf: 'https://www.17track.net/zh-cn',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/google.png'),
      // 名字
      name: '谷歌多国语言互译',
      // 站外链接
      hrefSelf: 'https://translate.google.cn/?sl=en&tl=zh-CN&op=translate',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/DeepL.png'),
      // 名字
      name: 'DeepL翻译',
      // 站外链接
      hrefSelf: 'https://www.deepl.com/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/金山词霸.png'),
      // 名字
      name: '金山翻译',
      // 站外链接
      hrefSelf: ' http://www.iciba.com/',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/查询货船位置.png'),
      // 名字
      name: '查询货船位置',
      // 站外链接
      hrefSelf: 'http://www.shipxy.com/',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/国际铁运货件查询.png'),
      // 名字
      name: '国际铁运货件查询',
      // 站外链接
      hrefSelf: 'http://hyfw.95306.cn/gateway/DzswNewD2D/Dzsw/page/business-chcx-hwzzsy',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/海空运跟踪查询.png'),
      // 名字
      name: '海空运跟踪查询',
      // 站外链接
      hrefSelf: 'http://www.yundangnet.com/cargoTrackings/cargoTrackingSea',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/全球集运查询.png'),
      // 名字
      name: '全球集运查询',
      // 站外链接
      hrefSelf: 'https://www.jytrack.com/ ',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/合规邀评.png'),
      // 名字
      name: '合规邀评',
      // 站外链接
      hrefSelf: 'https://www.junglescout.cn/get-reviews/?gspk=OTQ0&gsxid=L5mcONEtg9oZ&utm_medium=944&utm_source=affiliate',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/亚马逊综合运营.png'),
      // 名字
      name: '亚马逊综合运营',
      // 站外链接
      hrefSelf: 'https://amzscout.net/cn/ ',
    },
    {
      id: 12,
      // 小图标
      icon: require('../img/icon/亚马逊开店.png'),
      // 名字
      name: '亚马逊开店',
      // 站外链接
      hrefSelf: 'https://www.cifnews.com/article/23464',
    },
    {
      id: 13,
      // 小图标
      icon: require('../img/icon/AsinSeed.png'),
      // 名字
      name: 'AsinSeed关键词',
      // 站外链接
      hrefSelf: 'https://www.asinseed.com/cn',
    },

  ];
  // 常用外贸小工具
  let array_2 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/单位换算.png'),
      // 名字
      name: '单位换算',
      // 站外链接
      hrefSelf: 'http://www.pc6.com/z/hs/',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/今日汇率.png'),
      // 名字
      name: '汇率查询',
      // 站外链接
      hrefSelf: 'https://cn.investing.com/currencies/usd-cny-converter',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/世界时钟.png'),
      // 名字
      name: '世界时钟',
      // 站外链接
      hrefSelf: 'http://www.24timemap.com/',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/各国关税起征点.png'),
      // 名字
      name: '各国关税起征点',
      // 站外链接
      hrefSelf: 'https://waimaoquan.alibaba.com/newbbs/topic/1782358',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/HS商品查询.png'),
      // 名字
      name: 'HS商品编码查询',
      // 站外链接
      hrefSelf: 'http://www.hs-bianma.com/index.php',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/各国进口关税查询.png'),
      // 名字
      name: '各国进口关税查询',
      // 站外链接
      hrefSelf: 'http://db2.wtocenter.org.tw/tariff/search_byProducts.aspx',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/世界各国电话区号.png'),
      // 名字
      name: '世界各国电话区号',
      // 站外链接
      hrefSelf: 'http://lvyou168.cn/code_world.aspx',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/世界各国使用电压.png'),
      // 名字
      name: '世界各国使用电压',
      // 站外链接
      hrefSelf: 'https://www.maigoo.com/zhishi/143998.html',
    },
    {
      id: 8,
      // 小图标
      icon: require('../img/icon/世界各国假期.png'),
      // 名字
      name: '世界各国假期',
      // 站外链接
      hrefSelf: 'http://www.shijian.cc/jieri/',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/世界天气查询.png'),
      // 名字
      name: '世界天气查询',
      // 站外链接
      hrefSelf: 'http://www.tianqi234.com/shijietianqi/',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/世界各国数据.png'),
      // 名字
      name: '世界各国数据',
      // 站外链接
      hrefSelf: 'https://baike.baidu.com/item/%E4%B8%96%E7%95%8C%E5%90%84%E5%9B%BD',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/中国新旧历对照.png'),
      // 名字
      name: '中国新旧历切换',
      // 站外链接
      hrefSelf: 'https://gonglinongli.51240.com/',
    },
    {
      id: 12,
      // 小图标
      icon: require('../img/icon/世界海空运航线.png'),
      // 名字
      name: '世界港口及航线',
      // 站外链接
      hrefSelf: 'http://www.yicang.com/ports.html',
    },
    {
      id: 13,
      // 小图标
      icon: require('../img/icon/世界港口及航线.png'),
      // 名字
      name: '全球机场',
      // 站外链接
      hrefSelf: 'http://www.yicang.com/airports.html',
    },

    {
      id: 14,
      // 小图标
      icon: require('../img/icon/世界各地展会查询.png'),
      // 名字
      name: '世界各地展会查询',
      // 站外链接
      hrefSelf: 'http://www.eshow365.com/',
    },
  ];
  // 亚马逊论坛
  let array_3 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/跨境头条.png'),
      // 名字
      name: '跨境头条',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/forum-1.htm',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/创蓝论坛.png'),
      // 名字
      name: '创蓝论坛',
      // 站外链接
      hrefSelf: 'https://bbs.ichuanglan.com/',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/卖家之家.png'),
      // 名字
      name: '卖家之家',
      // 站外链接
      hrefSelf: 'https://mjzj.com/newmjzj',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/雨果网.png'),
      // 名字
      name: '雨果网',
      // 站外链接
      hrefSelf: 'https://www.cifnews.com/',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/跨境知道.png'),
      // 名字
      name: '跨境知道',
      // 站外链接
      hrefSelf: 'https://www.ikjzd.com/search/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/知无不言.png'),
      // 名字
      name: '知无不言',
      // 站外链接
      hrefSelf: 'http://www.wearesellers.com',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/亚马逊知识大纲.png'),
      // 名字
      name: '亚马逊知识大纲',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/dagang',
    },
  ];
  // 关键词分析
  let array_4 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/卖家精灵2.0.png'),
      // 名字
      name: '卖家精灵2.0',
      // 站外链接
      hrefSelf: 'https://www.sellersprite.com/cn/',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/SellerMotor.png'),
      // 名字
      name: 'SellerMotor',
      // 站外链接
      hrefSelf: 'https://www.sellermotor.com/',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/CaptainBI.png'),
      // 名字
      name: 'CaptainBI',
      // 站外链接
      hrefSelf: 'https://www.captainbi.com/',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/JungleScout.png'),
      // 名字
      name: 'JungleScout',
      // 站外链接
      hrefSelf: 'https://www.junglescout.com/',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/MerchantWords.png'),
      // 名字
      name: 'MerchantWords',
      // 站外链接
      hrefSelf: 'https://www.merchantwords.com/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/Sonar.png'),
      // 名字
      name: 'Sonar',
      // 站外链接
      hrefSelf: 'https://www.sonarqube.org/',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/Wordtracker.png'),
      // 名字
      name: 'Wordtracker',
      // 站外链接
      hrefSelf: 'https://www.wordtracker.com/',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/WordStream.png'),
      // 名字
      name: 'WordStream',
      // 站外链接
      hrefSelf: 'https://www.wordstream.com/keywords',
    },
    {
      id: 8,
      // 小图标
      icon: require('../img/icon/LongTailPro.png'),
      // 名字
      name: 'LongTailPro',
      // 站外链接
      hrefSelf: 'https://longtailpro.com/',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/KeyWordseverywhere.png'),
      // 名字
      name: 'KeyWordseverywhere',
      // 站外链接
      hrefSelf: 'https://keywordseverywhere.com/google-analytics-keyword-volume.html',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/KeywordTools.png'),
      // 名字
      name: 'KeywordTools',
      // 站外链接
      hrefSelf: 'https://keywordtool.io/',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/KeywordShitter.png'),
      // 名字
      name: 'KeywordShitter',
      // 站外链接
      hrefSelf: 'https://keywordseverywhere.com/keyword-shitter.html',
    },
    {
      id: 12,
      // 小图标
      icon: require('../img/icon/长尾词挖掘.png'),
      // 名字
      name: '长尾词挖掘',
      // 站外链接
      hrefSelf: 'https://ci.5118.com/',
    },
    {
      id: 13,
      // 小图标
      icon: require('../img/icon/AnswerThePublic.png'),
      // 名字
      name: 'AnswerThePublic',
      // 站外链接
      hrefSelf: 'https://answerthepublic.com/',
    },
    {
      id: 14,
      // 小图标
      icon: require('../img/icon/Scientific.png'),
      // 名字
      name: 'Scientific',
      // 站外链接
      hrefSelf: 'https://www.scientificamerican.com/',
    },
    {
      id: 15,
      // 小图标
      icon: require('../img/icon/关键词挖掘.png'),
      // 名字
      name: '关键词挖掘',
      // 站外链接
      hrefSelf: 'http://stool.chinaz.com/baidu/words.aspx',
    },
    {
      id: 16,
      // 小图标
      icon: require('../img/icon/关键词组合.png'),
      // 名字
      name: '关键词组合',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/tools-btgjc',
    },
    {
      id: 17,
      // 小图标
      icon: require('../img/icon/关键词过滤.png'),
      // 名字
      name: '关键词过滤',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/tools-guolvqi',
    }
  ];
  // 选品分析
  let array_5 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/JungleScout.png'),
      // 名字
      name: 'Jungle Scout',
      // 站外链接
      hrefSelf: 'https://www.junglescout.com/',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/BigTracker.png'),
      // 名字
      name: 'BigTracker',
      // 站外链接
      hrefSelf: 'https://www.bqool.com/',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/Marketplace.png'),
      // 名字
      name: 'Marketplace Pulse',
      // 站外链接
      hrefSelf: 'https://www.marketplacepulse.com/',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/AmzChart.png'),
      // 名字
      name: 'AmzChart',
      // 站外链接
      hrefSelf: 'https://amzchart.com/cn',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/Movers.png'),
      // 名字
      name: 'Movers & Shakers',
      // 站外链接
      hrefSelf: 'https://www.moversshakers.nl/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/Ebay.png'),
      // 名字
      name: 'Ebay Daily',
      // 站外链接
      hrefSelf: 'https://www.ebay.com/deals',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/google.png'),
      // 名字
      name: '谷歌趋势',
      // 站外链接
      hrefSelf: 'https://trends.google.com/',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/google.png'),
      // 名字
      name: '谷歌品类趋势',
      // 站外链接
      hrefSelf: 'https://www.thinkwithgoogle.com/feature/category-trends/us/month',
    },
    {
      id: 8,
      // 小图标
      icon: require('../img/icon/Today.jpg'),
      // 名字
      name: "Today's Deals",
      // 站外链接
      hrefSelf: 'https://deals.today.com/',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/Kickstarter.png'),
      // 名字
      name: 'Kickstarter',
      // 站外链接
      hrefSelf: 'https://www.kickstarter.com/?lang=zh',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/Indiegogo.png'),
      // 名字
      name: 'Indiegogo',
      // 站外链接
      hrefSelf: 'https://www.indiegogo.com/',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/阿里指数.png'),
      // 名字
      name: '阿里指数',
      // 站外链接
      hrefSelf: 'https://dt.alibaba.com/alizs.htm',
    },
  ];
  // 亚马逊运营综合软件
  let array_6 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/AMZScout.jpg'),
      // 名字
      name: 'AMZScout',
      // 站外链接
      hrefSelf: 'https://amzscout.idevaffiliate.com/idevaffiliate.php?id=658&url=1135',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/AMZHelper.jpg'),
      // 名字
      name: 'AMZHelper',
      // 站外链接
      hrefSelf: 'http://www.amzhelper.com/?3104',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/AMZShark.jpg'),
      // 名字
      name: 'AMZShark',
      // 站外链接
      hrefSelf: 'https://amzshark.com/',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/JungleScout.png'),
      // 名字
      name: 'JungleScout',
      // 站外链接
      hrefSelf: 'https://www.junglescout.cn/',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/tool4seller.jpg'),
      // 名字
      name: 'tool4seller',
      // 站外链接
      hrefSelf: 'https://www.tool4seller.cn/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/卖家精灵2.0.png'),
      // 名字
      name: '卖家精灵2.0',
      // 站外链接
      hrefSelf: 'https://www.sellersprite.com/cn/',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/Wordtracker.png'),
      // 名字
      name: 'MerchantSpring',
      // 站外链接
      hrefSelf: 'https://merchantspring.io/',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/SellerMotor.png'),
      // 名字
      name: 'SellerMotor',
      // 站外链接
      hrefSelf: 'https://www.sellermotor.com/',
    },
    {
      id: 8,
      // 小图标
      icon: require('../img/icon/BQool.jpg'),
      // 名字
      name: 'BQool比酷尔',
      // 站外链接
      hrefSelf: 'https://www.bqool.cn/',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/SellerApp.jpg'),
      // 名字
      name: 'SellerApp',
      // 站外链接
      hrefSelf: 'https://www.sellerapp.com/',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/AMZDataStudio.jpg'),
      // 名字
      name: 'AMZDataStudio',
      // 站外链接
      hrefSelf: 'https://amzdatastudio.com/user/referral/3b1e3ab0-a1cb-11e8-a9c9-59ecb47d42ce',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/Selling.jpg'),
      // 名字
      name: 'SellingExpress',
      // 站外链接
      hrefSelf: 'https://www.sellingexpress.net/',
    },
    {
      id: 12,
      // 小图标
      icon: require('../img/icon/SellerBoard.jpg'),
      // 名字
      name: 'SellerBoard',
      // 站外链接
      hrefSelf: 'https://sellerboard.com/',
    },
    {
      id: 13,
      // 小图标
      icon: require('../img/icon/亚马逊船长BI.jpg'),
      // 名字
      name: '亚马逊船长BI',
      // 站外链接
      hrefSelf: 'https://www.captainbi.com/amz_promote.html',
    },
    {
      id: 14,
      // 小图标
      icon: require('../img/icon/积加ERP.jpg'),
      // 名字
      name: '积加ERP',
      // 站外链接
      hrefSelf: 'https://www.gerpgo.com/',
    },
    {
      id: 15,
      // 小图标
      icon: require('../img/icon/AMZ ONE.jpg'),
      // 名字
      name: 'AMZ ONE',
      // 站外链接
      hrefSelf: 'https://amz.one/',
    },
    {
      id: 16,
      // 小图标
      icon: require('../img/icon/AMZTracker.jpg'),
      // 名字
      name: 'AMZ Tracker',
      // 站外链接
      hrefSelf: 'https://www.amztrackers.com/index_ch.php',
    },
    {
      id: 17,
      // 小图标
      icon: require('../img/icon/SoftTime 4.0.jpg'),
      // 名字
      name: 'SoftTime 4.0',
      // 站外链接
      hrefSelf: 'https://www.sorftime.com/pc',
    }
  ];
  // 法务商标专利
  let array_7 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/美国商标局.png'),
      // 名字
      name: '美国商标局',
      // 站外链接
      hrefSelf: 'https://www.uspto.gov/trademark',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/美国专利局.png'),
      // 名字
      name: '美国专利局',
      // 站外链接
      hrefSelf: 'https://www.uspto.gov/',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/欧洲商标局.png'),
      // 名字
      name: '欧洲商标局',
      // 站外链接
      hrefSelf: 'https://euipo.europa.eu/',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/欧洲专利局.png'),
      // 名字
      name: '欧洲专利局',
      // 站外链接
      hrefSelf: 'https://www.epo.org/',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/商标分类表.png'),
      // 名字
      name: '商标分类表',
      // 站外链接
      hrefSelf: 'http://www.sbfl.cn/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/英国商标局.png'),
      // 名字
      name: '英国商标局',
      // 站外链接
      hrefSelf: 'https://www.gov.uk/government/organisations/intellectual-property-office',
    },
    {
      id: 6,
      // 小图标
      icon: require('../img/icon/日本商标局.png'),
      // 名字
      name: '日本商标局',
      // 站外链接
      hrefSelf: 'https://www.jpo.go.jp/',
    },
    {
      id: 7,
      // 小图标
      icon: require('../img/icon/google.png'),
      // 名字
      name: '谷歌专利搜索',
      // 站外链接
      hrefSelf: 'https://www.google.com.hk/?tbm=pts',
    },
    {
      id: 8,
      // 小图标
      icon: require('../img/icon/Innojoy.png'),
      // 名字
      name: 'Innojoy',
      // 站外链接
      hrefSelf: 'http://www.daweisoft.com/innojoy/innojoy.html?p=20191030',
    },
    {
      id: 9,
      // 小图标
      icon: require('../img/icon/TradeMarkia.png'),
      // 名字
      name: 'TradeMarkia',
      // 站外链接
      hrefSelf: 'https://www.trademarkia.com/',
    },
    {
      id: 10,
      // 小图标
      icon: require('../img/icon/方信知识产权.png'),
      // 名字
      name: '方信知识产权',
      // 站外链接
      hrefSelf: 'https://www.cifnews.com/service/fangtion',
    },
    {
      id: 11,
      // 小图标
      icon: require('../img/icon/商标检索教程.png'),
      // 名字
      name: '商标检索教程',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/thread-322448.htm',
    },
    {
      id: 12,
      // 小图标
      icon: require('../img/icon/专利检索教程.png'),
      // 名字
      name: '专利检索教程',
      // 站外链接
      hrefSelf: 'https://www.amz123.com/thread-320331.htm',
    },
    {
      id: 13,
      // 小图标
      icon: require('../img/icon/亚速知识产权.png'),
      // 名字
      name: '亚速知识产权',
      // 站外链接
      hrefSelf: 'http://www.asintm.com/',
    },
    {
      id: 14,
      // 小图标
      icon: require('../img/icon/商标买卖查询.png'),
      // 名字
      name: '商标买卖查询',
      // 站外链接
      hrefSelf: 'https://www.maihui.com/',
    }
  ];
  // 税务财务
  let array_8 = [
    {
      id: 0,
      // 小图标
      icon: require('../img/icon/亚速知识产权.png'),
      // 名字
      name: '亚速知识产权',
      // 站外链接
      hrefSelf: 'http://www.asintm.com/',
    },
    {
      id: 1,
      // 小图标
      icon: require('../img/icon/方信知识产权.png'),
      // 名字
      name: '方信知识产权',
      // 站外链接
      hrefSelf: 'http://www.fangtion.com/',
    },
    {
      id: 2,
      // 小图标
      icon: require('../img/icon/欧洲商品合规.png'),
      // 名字
      name: '欧洲商品合规',
      // 站外链接
      hrefSelf: 'https://sellercentral.amazon.co.uk/gp/help/external/G3NRFVS4YUYRQ85J?language=zh_CN&ref=efph_G3NRFVS4YUYRQ85J_cont_UH6FA4XSJ2LZFLY',
    },
    {
      id: 3,
      // 小图标
      icon: require('../img/icon/欧税通.png'),
      // 名字
      name: '欧税通',
      // 站外链接
      hrefSelf: 'https://www.evatmaster.com/',
    },
    {
      id: 4,
      // 小图标
      icon: require('../img/icon/卖家成长VAT.png'),
      // 名字
      name: '卖家成长VAT',
      // 站外链接
      hrefSelf: 'https://www.sellergrowth.com/',
    },
    {
      id: 5,
      // 小图标
      icon: require('../img/icon/J&P会计事务所.png'),
      // 名字
      name: 'J&P会计事务所',
      // 站外链接
      hrefSelf: 'https://www.jpvat.cn/',
    },
  ]
  // // 测评服务
  // let array_9 = [
  //   {
  //     id: 0,
  //     // 小图标
  //     icon: require('../img/icon/卖家精灵2.0.png'),
  //     // 名字
  //     name: '卖家精灵2.0',
  //     // 站外链接
  //     hrefSelf: 'https://www.sellersprite.com/cn/',
  //   },
  //   {
  //     id: 1,
  //     // 小图标
  //     icon: require('../img/icon/SellerMotor.png'),
  //     // 名字
  //     name: 'SellerMotor',
  //     // 站外链接
  //     hrefSelf: 'https://www.sellermotor.com/',
  //   },
  //   {
  //     id: 2,
  //     // 小图标
  //     icon: require('../img/icon/CaptainBI.png'),
  //     // 名字
  //     name: 'CaptainBI',
  //     // 站外链接
  //     hrefSelf: 'https://www.captainbi.com/',
  //   },
  //   {
  //     id: 3,
  //     // 小图标
  //     icon: require('../img/icon/JungleScout.png'),
  //     // 名字
  //     name: 'JungleScout',
  //     // 站外链接
  //     hrefSelf: 'https://www.junglescout.com/',
  //   },
  //   {
  //     id: 4,
  //     // 小图标
  //     icon: require('../img/icon/MerchantWords.png'),
  //     // 名字
  //     name: 'MerchantWords',
  //     // 站外链接
  //     hrefSelf: 'https://www.merchantwords.com/',
  //   },
  //   {
  //     id: 5,
  //     // 小图标
  //     icon: require('../img/icon/Sonar.png'),
  //     // 名字
  //     name: 'Sonar',
  //     // 站外链接
  //     hrefSelf: 'https://www.sonarqube.org/',
  //   },
  //   {
  //     id: 6,
  //     // 小图标
  //     icon: require('../img/icon/Wordtracker.png'),
  //     // 名字
  //     name: 'Wordtracker',
  //     // 站外链接
  //     hrefSelf: 'https://www.wordtracker.com/',
  //   },
  //   {
  //     id: 7,
  //     // 小图标
  //     icon: require('../img/icon/KeywordToolDomina.png'),
  //     // 名字
  //     name: 'KeywordToolDomina',
  //     // 站外链接
  //     hrefSelf: 'https://keywordtool.io/',
  //   },
  //   {
  //     id: 8,
  //     // 小图标
  //     icon: require('../img/icon/LongTailPro.png'),
  //     // 名字
  //     name: 'LongTailPro',
  //     // 站外链接
  //     hrefSelf: 'https://longtailpro.com/',
  //   },
  //   {
  //     id: 9,
  //     // 小图标
  //     icon: require('../img/icon/KeyWordPlanner.png'),
  //     // 名字
  //     name: 'KeyWordPlanner',
  //     // 站外链接
  //     hrefSelf: 'https://keywordtool.io/',
  //   },
  //   {
  //     id: 10,
  //     // 小图标
  //     icon: require('../img/icon/KeywordTools.png'),
  //     // 名字
  //     name: 'KeywordTools',
  //     // 站外链接
  //     hrefSelf: 'https://keywordtool.io/',
  //   },
  //   {
  //     id: 11,
  //     // 小图标
  //     icon: require('../img/icon/KeywordShitter.png'),
  //     // 名字
  //     name: 'KeywordShitter',
  //     // 站外链接
  //     hrefSelf: 'https://keywordseverywhere.com/keyword-shitter.html',
  //   },
  //   {
  //     id: 12,
  //     // 小图标
  //     icon: require('../img/icon/长尾词挖掘.png'),
  //     // 名字
  //     name: '长尾词挖掘',
  //     // 站外链接
  //     hrefSelf: 'https://ci.5118.com/',
  //   },
  //   {
  //     id: 13,
  //     // 小图标
  //     icon: require('../img/icon/AnswerThePublic.png'),
  //     // 名字
  //     name: 'AnswerThePublic',
  //     // 站外链接
  //     hrefSelf: 'https://answerthepublic.com/',
  //   },
  //   {
  //     id: 14,
  //     // 小图标
  //     icon: require('../img/icon/Scientific.png'),
  //     // 名字
  //     name: 'Scientific',
  //     // 站外链接
  //     hrefSelf: 'https://www.scientificamerican.com/',
  //   },
  //   {
  //     id: 15,
  //     // 小图标
  //     icon: require('../img/icon/关键词挖掘.png'),
  //     // 名字
  //     name: '关键词挖掘',
  //     // 站外链接
  //     hrefSelf: 'http://stool.chinaz.com/baidu/words.aspx',
  //   },
  //   {
  //     id: 16,
  //     // 小图标
  //     icon: require('../img/icon/关键词组合.png'),
  //     // 名字
  //     name: '关键词组合',
  //     // 站外链接
  //     hrefSelf: 'https://www.amz123.com/tools-btgjc',
  //   },
  //   {
  //     id: 17,
  //     // 小图标
  //     icon: require('../img/icon/关键词过滤.png'),
  //     // 名字
  //     name: '关键词过滤',
  //     // 站外链接
  //     hrefSelf: 'https://www.amz123.com/tools-guolvqi',
  //   }
  // ];

  export default {
    name: "toolsContent",
    components:{
      "tool": siteTools,
      "extension": extensionTool,
    },
    data(){
      return{
        // 常用工具
        tools:[array_1, array_2, array_4, array_5, array_6, array_3, array_7, array_8],
        // 工具标题
        titles:['亚马逊常用小工具及链接', '常用外贸小工具', '关键词分析',
          '选品分析', '亚马逊运营综和软件', '亚马逊论坛', '法务商标专利', '税务财务'],
        // 是否显示快递公司选择
        companyShow: false,
        // 快递查询
        expressInquiry: '',
        // 可能的快递公司
        expressCompany: '',
        // 快递详情
        expressData: null,
        // 显示快递详情
        showExpressDetail: false,
        necessary: true,
      }
    },
    methods: {
      // 快递查询
      inquire(){
        const loading = this.$loading({
          lock: true,
          text: 'loading',
        })
        request({
          url: '/info/getLogistics',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "num": this.expressInquiry
          }
        }).then(res => {
          if(res.data.code === 2000){
            this.expressCompany = res.data.info
            this.companyShow = true
          }else if(res.data.code === 1){
            this.expressData = res.data.info
          }else if(res.data.code === 1018 || res.data.code === 1016){
            this.companyShow = false
            this.expressCompany = ''
            this.$message.error(res.data.info)
          }
        }).catch(err => {
          console.log(err)
        })
        loading.close()
      },
      // 快递查询
      inquireDetail(index){
        request({
          url: '/info/getLogistics',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "num": this.expressInquiry,
            "com": this.expressCompany[index].comCode
          }
        }).then(res => {
          if(res.data.code === 2000){
            this.expressCompany = res.data.info
            this.companyShow = true
          }else if(res.data.code === 1){
            this.expressData = res.data.info
            this.companyShow = false
            this.showExpressDetail = false
          }else {
            this.$message.error(res.data.info)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 对话框蒙层点击
      cancelShow(show){
        this.companyShow = show
      },
      changeNecessary(){
        this.necessary = true
      },
      // 取消快递查询
      cancelExpress(){
        this.companyShow = false
      },
      // 显示快递查询
      showExpress(){
        this.companyShow = true
        console.log(this.expressCompany)
      },
      showDetail(){
        this.showExpressDetail = true
      },
      cancelDetail(){
        this.showExpressDetail = false
      }
    },
    beforeUpdate() {
      if(this.expressInquiry.length >= 10 && this.expressInquiry.length < 32 && this.necessary){
        request({
          url: '/info/getLogistics',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "num": this.expressInquiry
          }
        }).then(res => {
          if(res.data.code === 2000){
            this.expressCompany = res.data.info
            this.companyShow = true
            this.necessary = false
          }else if(res.data.code === 1){
            this.expressData = res.data.info
            this.necessary = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
      if(!(this.expressInquiry.length >= 10 && this.expressInquiry.length < 32)){
        this.expressData = ''
      }
      if(this.expressInquiry.length === 0){
        this.expressCompany = null
      }
    }
  }
</script>

<style scoped>
  .tools{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .search_module{
    margin: 0 auto;
    border: 1px solid #d6e0ec;
    border-radius: 2px;
    position: relative;
  }

  .search_top{
    border-bottom: 1px solid #d6e0ec;
    display: flex;
  }

  .company_show{
    position: absolute;
    top: 35px;
    border: 1px solid #e6e6e6;
    border-top: none;
    background-color: #fff;
    z-index: 10;
  }

  .company_show div:hover{
    opacity: .8;
    cursor: pointer;
  }

  .search_bottom{
    overflow: auto;
  }

  .express_item{
    display: flex;
  }

  .express_time{
    color: #727272;
  }

  .express_img{
    height: 12px;
  }

  .express_context{
    color: black;
  }

  .search_img{
    height: 35px;
    margin-top: 1px;
  }

  .search_img img{
    height: 30px;
  }

  .search_top input{
    height: 35px;
    border: none;
    border-bottom: 1px solid #d6e0ec;
    border-left: 1px solid #d6e0ec;
    outline: none;
  }

  .search_top button{
    height: 35px;
    background-color: #d2e9fb;
    border: none;
    outline: none;
    color: #6e6e6e;
  }

  .search_top button:hover{
    opacity: .96;
    cursor: pointer;
  }

  @media screen and (max-width: 1422px) {
    .total{
      width: 95%;
    }

    .search_module{
      width: 30rem;
      height: 22rem;
    }

    .search_img img{
      margin: 1rem;
      transform: translate(-1.3rem, -1rem);
    }

    .search_top{
      height: 3.2rem;
    }

    .company_show{
      left: 3.6rem;
      width: 21rem;
    }

    .company_show div{
      padding: 5px 0.4rem;
    }

    .search_bottom{
      height: 18.6rem;
    }

    .express_item{
      margin: 10px 0.4rem;
    }

    .express_time{
      width: 6.5rem;
      font-size: 0.5rem;
      margin: 0 0.1rem;
    }

    .express_img{
      width: 2rem;
      padding: 0 0.4rem;
    }

    .express_context{
      width: 21rem;
      font-size: 1rem;
    }

    .search_img{
      width: 3rem;
      margin-left: 0.6rem;
    }

    .search_img img{
      width: 2.8rem;
    }

    .search_top input{
      width: 21rem;
      padding: 2px 0.4rem;
    }

    .search_top button{
      width: 7rem;
      font-size: 1.2rem;
    }
  }

  @media screen and (max-width: 1600px) and (min-width: 1423px) {
    .total{
      width: 86%;
      min-width: 120rem;
    }

    .search_module{
      width: 34rem;
      height: 22rem;
    }

    .search_img img{
      margin: 1rem;
      transform: translate(-1.3rem, -1rem);
    }

    .search_top{
      height: 3.2rem;
    }

    .company_show{
      left: 3.6rem;
      width: 25rem;
    }

    .company_show div{
      padding: 5px 0.4rem;
    }

    .search_bottom{
      height: 18.7rem;
    }

    .express_item{
      margin: 10px 0.4rem;
    }

    .express_time{
      width: 7rem;
      font-size: 1rem;
      margin: 0 0.1rem;
    }

    .express_img{
      width: 2rem;
      padding: 0 0.4rem;
    }

    .express_context{
      width: 29rem;
      font-size: 1rem;
    }

    .search_img{
      width: 3rem;
      margin-left: 0.6rem;
    }

    .search_img img{
      width: 2.8rem;
    }

    .search_top input{
      width: 25rem;
      padding: 2px 0.4rem;
    }

    .search_top button{
      width: 7rem;
      font-size: 1.2rem;
    }
  }

  @media screen and (min-width: 1600px){
    .total{
      width: 100%;
    }

    .search_module{
      width: 450px;
      height: 250px;
    }

    .search_img img{
      margin: 10px;
    }

    .search_top{
      height: 36px;
    }

    .company_show{
      left: 50px;
      width: 320px;
    }

    .company_show div{
      padding: 5px;
    }

    .search_bottom{
      height: 212px;
    }

    .express_item{
      margin: 10px 5px;
    }

    .express_time{
      width: 70px;
      font-size: 12px;
      margin: 0 1px;
    }

    .express_img{
      width: 20px;
      padding: 0 5px;
    }

    .express_context{
      width: 290px;
      font-size: 12px;
    }

    .search_img{
      width: 50px;
      transform: translateY(-8px);
    }

    .search_img img{
      width: 30px;
    }

    .search_top input{
      width: 320px;
      padding: 2px 5px;
    }

    .search_top button{
      width: 80px;
      font-size: 12px;
    }
  }
</style>
